(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  var sections = document.querySelectorAll('.brand-slider');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  sections.forEach(function (section) {
    var panel = section.querySelector('[data-brand-panel]');
    var track = section.querySelector('[data-brand-track]');
    var prev = section.querySelector('[data-brand-prev]');
    var next = section.querySelector('[data-brand-next]');
    var dotsWrap = section.querySelector('[data-brand-dots]');
    if (!track) return;

    /* --- Einblenden beim Scrollen in den Viewport --- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            section.classList.add('is-inview');
            io.disconnect();
          }
        });
      }, { threshold: 0.15 });
      io.observe(section);
    } else {
      section.classList.add('is-inview');
    }

    /* --- Aktive Karte folgt dem Hover --- */
    var cards = Array.prototype.slice.call(section.querySelectorAll('.brand-slider__card'));
    function setActive(card) {
      cards.forEach(function (c) { c.classList.toggle('is-active', c === card); });
    }
    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () { setActive(card); });
      card.addEventListener('focusin', function () { setActive(card); });
    });
    if (panel) {
      panel.addEventListener('mouseleave', function () { setActive(cards[0]); });
    }

    /* --- Paging (Pfeile + Dots) --- */
    function maxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }
    /* Seitenbreite anhand der echten Kartenbreite – damit Dots-Anzahl
       und Scroll-Ziele exakt zu den sichtbaren Karten passen. */
    function metrics() {
      var items = track.children;
      if (!items.length) return { pageW: track.clientWidth, count: 1 };
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      /* offsetWidth statt getBoundingClientRect: nicht von der Einblend-
         Animation (CSS transform) verfälscht → korrekte Seitenbreite */
      var itemW = items[0].offsetWidth + gap;
      var perPage = Math.max(1, Math.round(track.clientWidth / itemW));
      var count = Math.max(1, Math.ceil(items.length / perPage));
      return { pageW: perPage * itemW, count: count };
    }
    function pages() {
      return metrics().count;
    }
    function currentPage() {
      var m = metrics();
      if (track.scrollLeft >= maxScroll() - 2) return m.count - 1;
      return Math.min(m.count - 1, Math.round(track.scrollLeft / m.pageW));
    }
    function buildDots() {
      if (!dotsWrap) return;
      var n = pages();
      if (n <= 1) { dotsWrap.innerHTML = ''; return; }
      var html = '';
      for (var i = 0; i < n; i++) {
        html += '<button type="button" class="brand-slider__dot" data-page="' + i + '" aria-label="Seite ' + (i + 1) + '"></button>';
      }
      dotsWrap.innerHTML = html;
      syncUi();
    }
    function syncUi() {
      var p = currentPage();
      if (dotsWrap) {
        dotsWrap.querySelectorAll('.brand-slider__dot').forEach(function (d, i) {
          d.classList.toggle('is-active', i === p);
        });
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 2);
    }
    /* Einblend-Animation bei erster Interaktion sofort abschließen –
       sonst überlagern sich vertikales Einsetzen + horizontales Scrollen. */
    var entranceSettled = false;
    function settleEntrance() {
      if (entranceSettled) return;
      entranceSettled = true;
      section.classList.add('is-inview');
      var its = track.children;
      for (var i = 0; i < its.length; i++) its[i].style.transition = 'none';
      void track.offsetWidth;
      for (var i = 0; i < its.length; i++) its[i].style.transition = '';
    }
    function goTo(page) {
      settleEntrance();
      var m = metrics();
      page = Math.max(0, Math.min(page, m.count - 1));
      var left = page * m.pageW;
      /* Letzte Seite immer bis ans Scroll-Ende – so ist der letzte Dot erreichbar. */
      if (page === m.count - 1) left = maxScroll();
      track.scrollTo({ left: Math.min(left, maxScroll()), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { goTo(currentPage() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentPage() + 1); });
    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-page]');
        if (dot) goTo(parseInt(dot.dataset.page, 10));
      });
    }

    var scrollRaf = null;
    track.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        scrollRaf = null;
        syncUi();
      });
    }, { passive: true });

    window.addEventListener('resize', function () { buildDots(); });
    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', buildDots, { once: true });
    });

    buildDots();
    syncUi();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-ratgeber"] && !Shopify.designMode) return;
  try {
    
/* Kategorie-Ratgeber: langen Text einklappen, Inhaltsverzeichnis mit
   aktivem Abschnitt. Ohne JS bleibt alles offen und die Anker springen. */
(function () {
  function init(root) {
    var sec = (root || document).querySelector('.cguide');
    if (!sec || sec.dataset.cguideReady) return;
    sec.dataset.cguideReady = '1';

    var body = sec.querySelector('.cguide__body');
    var btn = sec.querySelector('.cguide__more');
    var label = btn && btn.querySelector('.cguide__more-label');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function expand() {
      if (!body.hasAttribute('data-collapsed')) return;
      body.removeAttribute('data-collapsed');
      btn.setAttribute('aria-expanded', 'true');
      label.textContent = 'Weniger anzeigen';
    }

    // Nur einklappen, wenn deutlich mehr Text da ist als der Ausschnitt zeigt
    if (btn && body.hasAttribute('data-cguide-collapse') && body.scrollHeight > 560) {
      body.setAttribute('data-collapsed', '');
      btn.hidden = false;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        if (body.hasAttribute('data-collapsed')) {
          expand();
        } else {
          body.setAttribute('data-collapsed', '');
          btn.setAttribute('aria-expanded', 'false');
          label.textContent = 'Weiterlesen';
          sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    // Sprung ins Inhaltsverzeichnis: Ziel im eingeklappten Teil? Erst aufklappen.
    var links = Array.prototype.slice.call(sec.querySelectorAll('.cguide__toc-link'));
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById(a.getAttribute('href').slice(1));
        if (!target) return;
        e.preventDefault();
        if (btn && body.contains(target)) expand();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', a.getAttribute('href'));
      });
    });

    // Direkt mit #rg-… aufgerufen? Dann aufklappen, damit das Ziel sichtbar ist.
    if (btn && location.hash.indexOf('#rg-') === 0) {
      var t = document.getElementById(location.hash.slice(1));
      if (t && body.contains(t)) { expand(); t.scrollIntoView(); }
    }

    // Aktiven Abschnitt im Inhaltsverzeichnis markieren
    if (links.length && 'IntersectionObserver' in window) {
      var byId = {};
      links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (l) { l.removeAttribute('aria-current'); });
          if (byId[en.target.id]) byId[en.target.id].setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '-15% 0px -70% 0px' });
      Object.keys(byId).forEach(function (id) {
        var el = document.getElementById(id);
        if (el) io.observe(el);
      });
      links[0].setAttribute('aria-current', 'true');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
/* Motorrad-Feld aus der Fahrzeugsuche vorbefüllen, wenn eins gewählt ist. */
(function () {
  function fill() {
    const field = document.querySelector('[data-ctf-vehicle]');
    if (!field || field.value) return;
    let v = null;
    try { v = JSON.parse(localStorage.getItem('tsstec.vehicle') || 'null'); } catch (e) { return; }
    if (!v || !v.model) return;
    field.value = v.label || ((v.brand || '') + ' ' + v.model).trim();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fill);
  } else {
    fill();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitment-banner"]) return;
  try {
    
/* Der Fahrzeugname kommt serverseitig aus collection.filters. Wenn der
   Storefront-Filter dort keinen aktiven Wert liefert (z. B. weil die Seite
   ohne Filter-Parameter aufgerufen wurde), fällt die Überschrift auf den
   generischen Text zurück. Dann das gewählte Motorrad aus dem localStorage
   nachtragen — dieselbe Quelle, aus der auch die Leiste unter dem Header liest. */
(function () {
  const KEEP_CAPS = ['BMW', 'KTM', 'SYM', 'MV', 'GASGAS', 'CF'];

  function formatBrand(name) {
    if (!name) return '';
    return String(name).split(/\s+/).map((w) =>
      KEEP_CAPS.indexOf(w.toUpperCase()) !== -1
        ? w.toUpperCase()
        : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()
    ).join(' ');
  }

  function label(v) {
    if (!v || !v.model) return '';
    const years = v.year_to && v.year_to !== v.year_from
      ? v.year_from + '–' + v.year_to
      : (v.year_from || '');
    const base = (formatBrand(v.brand) + ' ' + v.model).trim();
    return years ? base + ' (' + years + ')' : base;
  }

  function sync() {
    const hero = document.querySelector('[data-fit-hero]');
    if (!hero || hero.hasAttribute('data-fit-hero-resolved')) return;

    const titleEl = hero.querySelector('[data-fit-hero-title]');
    const subEl = hero.querySelector('[data-fit-hero-sub]');
    if (!titleEl || !subEl) return;

    /* Ausgangstexte einmal sichern, damit beim Abwählen zurückgesetzt wird */
    if (!titleEl.dataset.fallback) titleEl.dataset.fallback = titleEl.textContent.trim();
    if (!subEl.dataset.fallback) subEl.dataset.fallback = subEl.textContent.trim();

    let vehicle = null;
    try { vehicle = JSON.parse(localStorage.getItem('tsstec.vehicle') || 'null'); } catch (e) {}
    const name = label(vehicle);

    if (name) {
      titleEl.textContent = 'Passende Teile für ' + name;
      subEl.textContent = 'Alle Teile aus unserem Sortiment, die zu deinem ' + name + ' passen.';
    } else {
      titleEl.textContent = titleEl.dataset.fallback;
      subEl.textContent = subEl.dataset.fallback;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  document.addEventListener('tsstec:vehicle:changed', sync);
  document.addEventListener('tsstec:vehicle:cleared', sync);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
/* Die Gruppen sind im Markup offen, damit sie ohne JS und für Crawler
   sichtbar bleiben. Unterhalb von 750px werden sie zugeklappt. */
(function () {
  const mq = window.matchMedia('(min-width: 750px)');

  function sync() {
    const groups = document.querySelectorAll('[data-footer-acc]');
    groups.forEach((el) => {
      if (mq.matches) {
        el.open = true;
        el.removeAttribute('data-collapsed');
      } else if (!el.hasAttribute('data-collapsed')) {
        /* Nur beim ersten Wechsel auf Mobile schließen — danach entscheidet
           die Nutzerin selbst, sonst springt es bei jedem Resize zu. */
        el.open = false;
        el.setAttribute('data-collapsed', '');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  mq.addEventListener('change', sync);
})();

/* Sanftes Auf-/Zuklappen: natives <details> springt hart — Klick abfangen,
   die Höhe der Linkliste animieren und den open-Zustand beim Schließen erst
   nach der Animation umschalten (vorher würde der Browser den Inhalt sofort
   ausblenden). */
(function () {
  const mqDesktop = window.matchMedia('(min-width: 750px)');
  const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';

  document.addEventListener('click', (e) => {
    const summary = e.target.closest('.fsite__summary');
    if (!summary) return;
    const details = summary.closest('details[data-footer-acc]');
    if (!details) return;
    e.preventDefault();

    /* Desktop: Gruppen sind fixiert offen. pointer-events stoppt nur die
       Maus — Enter auf fokussiertem summary landet ebenfalls hier. */
    if (mqDesktop.matches) return;
    if (details.dataset.animating) return;

    const content = details.querySelector('.fsite__links');
    if (!content || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      details.open = !details.open;
      return;
    }

    details.dataset.animating = '1';
    content.style.overflow = 'hidden';
    const done = () => {
      content.style.overflow = '';
      delete details.dataset.animating;
      details.removeAttribute('data-closing');
    };

    if (details.open) {
      details.setAttribute('data-closing', ''); /* Chevron dreht sofort zurück */
      const anim = content.animate(
        [
          { height: content.offsetHeight + 'px', opacity: 1 },
          { height: '0px', opacity: 0 }
        ],
        { duration: 240, easing: EASE }
      );
      anim.onfinish = () => { details.open = false; done(); };
      anim.oncancel = done;
    } else {
      details.open = true;
      const anim = content.animate(
        [
          { height: '0px', opacity: 0 },
          { height: content.offsetHeight + 'px', opacity: 1 }
        ],
        { duration: 280, easing: EASE }
      );
      anim.onfinish = done;
      anim.oncancel = done;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-stage"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;
  const hero = document.querySelector('.hero-stage');
  if (!hero) return;

  let targetX = 0, targetY = 0, currentX = 0, currentY = 0, raf = null;

  function update() {
    currentX += (targetX - currentX) * 0.08;
    currentY += (targetY - currentY) * 0.08;
    hero.style.setProperty('--parallax-x', currentX.toFixed(3));
    hero.style.setProperty('--parallax-y', currentY.toFixed(3));
    if (Math.abs(targetX - currentX) > 0.001 || Math.abs(targetY - currentY) > 0.001) {
      raf = requestAnimationFrame(update);
    } else {
      raf = null;
    }
  }

  hero.addEventListener('mousemove', (e) => {
    const rect = hero.getBoundingClientRect();
    targetX = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
    targetY = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
    if (!raf) raf = requestAnimationFrame(update);
  }, { passive: true });

  hero.addEventListener('mouseleave', () => {
    targetX = 0; targetY = 0;
    if (!raf) raf = requestAnimationFrame(update);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
/* „Mehr lesen“ öffnet das mobil gekürzte Intro. Passt der Text doch in
   drei Zeilen, verschwindet der Button. */
(function () {
  function init() {
    var desc = document.getElementById('CollHeroDesc');
    var btn = document.querySelector('.coll-hero__more');
    if (!desc || !btn || btn.dataset.ready) return;
    btn.dataset.ready = '1';
    var first = desc.firstElementChild;
    if (window.matchMedia('(max-width: 749.98px)').matches && first &&
        first.scrollHeight <= first.clientHeight + 2 && desc.children.length < 2) {
      desc.classList.remove('coll-hero__desc--clamp');
      return;
    }
    btn.addEventListener('click', function () {
      desc.classList.remove('coll-hero__desc--clamp');
      btn.setAttribute('aria-expanded', 'true');
      btn.hidden = true;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class TsstecPdpGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
    this.count = this.thumbs.length;
    this.index = 0;
    this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i)));
    const prev = this.querySelector('[data-prev]');
    const next = this.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
    if (next) next.addEventListener('click', () => this.go(this.index + 1));

    this.initLightbox();

    const thumbsEl = this.querySelector('[data-thumbs]');
    const up = this.querySelector('[data-thumb-up]');
    const down = this.querySelector('[data-thumb-down]');
    if (thumbsEl && up && down) {
      if (thumbsEl.scrollHeight <= thumbsEl.clientHeight + 4) {
        up.style.display = 'none';
        down.style.display = 'none';
      } else {
        up.addEventListener('click', () => thumbsEl.scrollBy({ top: -200, behavior: 'smooth' }));
        down.addEventListener('click', () => thumbsEl.scrollBy({ top: 200, behavior: 'smooth' }));
      }
    }
  }
  go(i) {
    if (this.count < 1) return;
    this.index = (i + this.count) % this.count;
    if (this.track) this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
    this.thumbs.forEach((t, ti) => {
      const on = ti === this.index;
      t.classList.toggle('is-active', on);
      if (on) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }

  /* Großansicht: Klick aufs Bühnenbild öffnet das <dialog>, dort Blättern
     per Button, Pfeiltasten, Thumbnail oder Wischen. */
  initLightbox() {
    this.lb = this.querySelector('[data-lightbox]');
    if (!this.lb || !this.lb.showModal) return;

    this.lbImg = this.lb.querySelector('[data-lb-img]');
    this.lbCounter = this.lb.querySelector('[data-lb-counter]');
    this.lbThumbs = Array.from(this.lb.querySelectorAll('[data-lb-thumb]'));
    this.lbSources = Array.from(this.lb.querySelectorAll('[data-lb-src]')).map((el) => ({
      src: el.dataset.lbSrc,
      alt: el.dataset.lbAlt || '',
    }));
    if (!this.lbSources.length) return;

    this.querySelectorAll('.pdp-gal__slide img').forEach((img, i) => {
      img.addEventListener('click', () => this.openLightbox(i));
    });

    const prev = this.lb.querySelector('[data-lb-prev]');
    const next = this.lb.querySelector('[data-lb-next]');
    if (prev) prev.addEventListener('click', () => this.lbGo(this.lbIndex - 1));
    if (next) next.addEventListener('click', () => this.lbGo(this.lbIndex + 1));
    this.lbThumbs.forEach((t, i) => t.addEventListener('click', () => this.lbGo(i)));

    const close = this.lb.querySelector('[data-lb-close]');
    if (close) close.addEventListener('click', () => this.lb.close());
    /* Klick auf den Backdrop schließt — das <dialog> selbst ist das
       Klickziel, sobald man neben den Inhalt trifft. */
    this.lb.addEventListener('click', (e) => { if (e.target === this.lb) this.lb.close(); });

    this.lb.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); this.lbGo(this.lbIndex + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.lbGo(this.lbIndex - 1); }
    });

    /* Wischen auf Touch */
    let startX = null;
    const stage = this.lb.querySelector('.pdp-lb__stage');
    stage.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) this.lbGo(this.lbIndex + (dx < 0 ? 1 : -1));
      startX = null;
    }, { passive: true });

    /* Beim Schließen die Auswahl in die Hauptgalerie zurückspiegeln */
    this.lb.addEventListener('close', () => { this.go(this.lbIndex); });
  }

  openLightbox(i) {
    if (!this.lb) return;
    this.lbGo(i);
    this.lb.showModal();
  }

  lbGo(i) {
    const n = this.lbSources.length;
    if (!n) return;
    this.lbIndex = (i + n) % n;
    const item = this.lbSources[this.lbIndex];
    this.lbImg.src = item.src;
    this.lbImg.alt = item.alt;
    if (this.lbCounter) this.lbCounter.textContent = (this.lbIndex + 1) + ' / ' + n;
    this.lbThumbs.forEach((t, ti) => {
      const on = ti === this.lbIndex;
      t.classList.toggle('is-active', on);
      if (on) t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  }
}
if (!customElements.get('tsstec-pdp-gallery')) customElements.define('tsstec-pdp-gallery', TsstecPdpGallery);

document.addEventListener('click', (e) => {
  const qty = e.target.closest('[data-qty]');
  if (qty) {
    const input = qty.querySelector('[data-qty-input]');
    // Mengenregeln der Variante respektieren statt hart +/- 1 ab 1.
    const qMin = parseInt(input.dataset.min, 10) || 1;
    const qStep = parseInt(input.dataset.step, 10) || 1;
    const qMax = input.dataset.max ? parseInt(input.dataset.max, 10) : Infinity;
    const qCur = parseInt(input.value, 10) || qMin;
    if (e.target.closest('[data-qty-plus]')) input.value = Math.min(qMax, qCur + qStep);
    if (e.target.closest('[data-qty-minus]')) input.value = Math.max(qMin, qCur - qStep);
  }
  const relPrev = e.target.closest('[data-rel-prev]');
  const relNext = e.target.closest('[data-rel-next]');
  if (relPrev || relNext) {
    const track = (relPrev || relNext).closest('.pdp-related').querySelector('[data-rel-track]');
    const step = track.querySelector('.pdp-related__item');
    const dx = step ? step.offsetWidth + 16 : 280;
    track.scrollBy({ left: relNext ? dx : -dx, behavior: 'smooth' });
  }
  const fitOpen = e.target.closest('[data-fit-open]');
  if (fitOpen) {
    const box = fitOpen.closest('.pdp-box');
    const modal = box && box.querySelector('[data-fit-modal]');
    if (modal && modal.showModal) {
      modal.showModal();
      tsstecEnrichFitModal(modal);
      const search = modal.querySelector('[data-fit-search]');
      if (search) {
        search.value = '';
        modal.querySelectorAll('.pdp-fitmodal__item').forEach((it) => { it.hidden = false; });
        const countEl = modal.querySelector('[data-fit-count]');
        const total = modal.querySelectorAll('.pdp-fitmodal__item').length;
        if (countEl) countEl.textContent = '(' + total + ')';
        const emptyEl = modal.querySelector('[data-fit-empty]');
        if (emptyEl) emptyEl.hidden = true;
        setTimeout(() => search.focus(), 50);
      }
    }
  }
  if (e.target.closest('[data-fit-close]')) {
    const d = e.target.closest('dialog');
    if (d) d.close();
  }
  if (e.target.matches('[data-fit-modal]')) e.target.close();
});

/* Liquid rendert bei Referenzlisten max. 50 Einträge — bei gekappten Listen
   die komplette Fahrzeugliste aus dem Frontend-Index nachladen und ersetzen. */
async function tsstecEnrichFitModal(modal) {
  if (!modal.hasAttribute('data-fit-truncated') || modal.dataset.fitEnriched) return;
  modal.dataset.fitEnriched = '1';
  const sku = modal.dataset.fitSku;
  const indexUrl = modal.dataset.fitIndex;
  const vehiclesUrl = window.tsstec && window.tsstec.vehiclesUrl;
  if (!sku || !indexUrl || !vehiclesUrl) return;
  try {
    const [idxRes, vehRes] = await Promise.all([
      fetch(indexUrl),
      fetch(vehiclesUrl, { credentials: 'same-origin' }),
    ]);
    if (!idxRes.ok || !vehRes.ok) return;
    const index = await idxRes.json();
    const vehData = await vehRes.json();
    const byHandle = {};
    (vehData.vehicles || []).forEach((v) => { byHandle[v.handle] = v; });
    const matches = [];
    Object.keys(index).forEach((handle) => {
      if (index[handle].indexOf(sku) !== -1 && byHandle[handle]) matches.push(byHandle[handle]);
    });
    const list = modal.querySelector('.pdp-fitmodal__list');
    if (!list || matches.length <= list.children.length) return;
    matches.sort((a, b) =>
      (a.brand || '').localeCompare(b.brand || '', 'de') ||
      (a.model || '').localeCompare(b.model || '', 'de') ||
      (a.year_from || 0) - (b.year_from || 0)
    );
    list.innerHTML = '';
    matches.forEach((v) => {
      const years = v.year_to && v.year_to !== v.year_from ? v.year_from + '–' + v.year_to : String(v.year_from || '');
      const li = document.createElement('li');
      li.className = 'pdp-fitmodal__item';
      if (v.gid) li.setAttribute('data-vehicle-gid', v.gid);
      li.setAttribute('data-fit-search-blob', ((v.brand || '') + ' ' + (v.model || '') + ' ' + years).toLowerCase());
      const brand = document.createElement('span');
      brand.className = 'pdp-fitmodal__brand';
      brand.textContent = v.brand || '';
      li.appendChild(brand);
      const model = document.createElement('span');
      model.className = 'pdp-fitmodal__model';
      model.textContent = v.model || '';
      li.appendChild(model);
      if (years) {
        const y = document.createElement('span');
        y.className = 'pdp-fitmodal__years';
        y.textContent = years;
        li.appendChild(y);
      }
      list.appendChild(li);
    });
    const countEl = modal.querySelector('[data-fit-count]');
    if (countEl) countEl.textContent = '(' + matches.length + ')';
    const box = modal.closest('.pdp-box');
    const openBtn = box && box.querySelector('[data-fit-open]');
    if (openBtn && openBtn.firstChild && openBtn.firstChild.nodeType === Node.TEXT_NODE) {
      openBtn.firstChild.textContent = 'Alle ' + matches.length + ' kompatiblen Modelle ';
    }
  } catch (err) {
    console.error('[fit-modal]', err);
  }
}

document.addEventListener('input', (e) => {
  if (!e.target.matches('[data-fit-search]')) return;
  const modal = e.target.closest('dialog');
  if (!modal) return;
  const q = e.target.value.trim().toLowerCase();
  const items = modal.querySelectorAll('.pdp-fitmodal__item');
  const countEl = modal.querySelector('[data-fit-count]');
  const emptyEl = modal.querySelector('[data-fit-empty]');
  const total = items.length;
  let visible = 0;
  items.forEach((it) => {
    const match = !q || (it.getAttribute('data-fit-search-blob') || '').includes(q);
    it.hidden = !match;
    if (match) visible++;
  });
  if (countEl) countEl.textContent = q ? '(' + visible + '/' + total + ')' : '(' + total + ')';
  if (emptyEl) emptyEl.hidden = visible > 0;
});

document.addEventListener('change', (e) => {
  if (e.target.matches('[data-variant-select]')) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', e.target.value);
    window.location.href = url.toString();
  }
});

document.addEventListener('submit', (e) => {
  const form = e.target;
  // getAttribute statt form.id: das Feld name="id" (Varianten-ID) überschattet
  // die id-Property des Formulars mit dem Element selbst.
  if (form.getAttribute('id') !== 'pdp-form') return;
  e.preventDefault();
  const btn = form.querySelector('.pdp__atc');
  const label = btn ? btn.querySelector('span') : null;
  if (btn) btn.disabled = true;
  if (label) label.textContent = 'Wird hinzugefügt …';
  // Warenkorb-Drawer öffnen statt Toast: die Sections des Drawers werden per
  // Bundled Section Rendering direkt mit der Add-Antwort mitgeliefert.
  const cartDrawer = document.querySelector('cart-drawer');
  const formData = new FormData(form);
  if (cartDrawer) {
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: formData,
  })
    .then((r) => r.json())
    .then((data) => {
      if (data.status) throw new Error(data.description || 'Fehler');
      if (cartDrawer && data.sections) {
        cartDrawer.renderContents(data);
        return null;
      }
      return fetch(window.Shopify.routes.root + 'cart.js').then((r) => r.json());
    })
    .then((cart) => {
      if (!cart) return;
      document
        .querySelectorAll('.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble > span:first-child')
        .forEach((el) => { el.textContent = cart.item_count; });
      TsstecPdpToast('Im Warenkorb', true);
    })
    .catch((err) => TsstecPdpToast(err.message || 'Konnte nicht hinzugefügt werden', false))
    .finally(() => {
      if (btn) btn.disabled = false;
      if (label) label.textContent = 'In den Warenkorb';
    });
});

function TsstecPdpToast(msg, ok) {
  let t = document.getElementById('tsstec-pdp-toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'tsstec-pdp-toast';
    t.style.cssText = 'position:fixed;z-index:9999;right:2rem;bottom:2rem;display:flex;align-items:center;gap:1rem;padding:1.3rem 1.8rem;border-radius:1rem;background:#0d0d0d;color:#fff;font-size:1.4rem;font-weight:700;box-shadow:0 10px 30px rgba(0,0,0,.3);transform:translateY(140%);transition:transform .35s cubic-bezier(.4,0,.2,1)';
    document.body.appendChild(t);
  }
  t.innerHTML = (ok ? '✓ ' : '✕ ') + msg + (ok ? ' &nbsp;<a href="' + window.Shopify.routes.root + 'cart" style="color:#fff;text-decoration:underline">Zum Warenkorb</a>' : '');
  t.style.background = ok ? '#0d0d0d' : '#b00020';
  requestAnimationFrame(() => { t.style.transform = 'translateY(0)'; });
  clearTimeout(t._timer);
  t._timer = setTimeout(() => { t.style.transform = 'translateY(140%)'; }, 4500);
}

/* „Mehr lesen" — weich zur Produktbeschreibung scrollen und sie kurz markieren. */
document.addEventListener('click', (e) => {
  const jump = e.target.closest('[data-desc-jump]');
  if (!jump) return;
  const target = document.getElementById('produktbeschreibung');
  if (!target) return;
  e.preventDefault();

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });

  target.classList.remove('pdp-desc--flash');
  void target.offsetWidth; /* Reflow erzwingen, sonst startet die Animation beim 2. Klick nicht */
  target.classList.add('pdp-desc--flash');

  target.focus({ preventScroll: true });
  history.replaceState(null, '', '#produktbeschreibung');
});

document.addEventListener('animationend', (e) => {
  if (e.animationName === 'pdpDescFlash') e.target.classList.remove('pdp-desc--flash');
});

/* ------------------------------------------------------------------
   „Passend für"-Box: das im Fahrzeugfilter gewählte Motorrad (localStorage
   `tsstec.vehicle`) grün markieren und nach oben ziehen. Steht es nicht
   unter den ersten drei, wird ein eigener Eintrag eingefügt.
   ------------------------------------------------------------------ */
(function () {
  const STORAGE_KEY = 'tsstec.vehicle';

  function storedVehicle() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null'); }
    catch (e) { return null; }
  }

  function norm(s) {
    return (s || '').toString().toLowerCase().replace(/\s+/g, ' ').trim();
  }

  /* Zwei Wege, damit der Treffer nicht allein an der GID hängt: erst die
     Metaobjekt-ID, sonst Marke + Modell aus dem sichtbaren Text. */
  function itemMatches(el, vehicle) {
    const gid = el.getAttribute('data-vehicle-gid');
    if (gid && vehicle.gid && gid === vehicle.gid) return true;
    const brand = el.querySelector('.pdp-fit__brand, .pdp-fitmodal__brand');
    const model = el.querySelector('.pdp-fit__model, .pdp-fitmodal__model');
    if (!brand || !model) return false;
    return norm(brand.textContent) === norm(vehicle.brand)
      && norm(model.textContent) === norm(vehicle.model);
  }

  function findMatch(root, selector, vehicle) {
    const items = root.querySelectorAll(selector);
    for (let i = 0; i < items.length; i++) {
      if (itemMatches(items[i], vehicle)) return items[i];
    }
    return null;
  }

  function yearLabel(v) {
    if (!v.year_from) return '';
    if (v.year_to && v.year_to !== v.year_from) return v.year_from + '-' + v.year_to;
    return String(v.year_from);
  }

  function flagNode() {
    const flag = document.createElement('span');
    flag.className = 'pdp-fit__match-flag';
    flag.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="9"/><path d="m8 12 2.8 2.8L16 9.6"/></svg>' +
      '<span>Dein Motorrad</span>';
    return flag;
  }

  function markExisting(item) {
    if (item.classList.contains('pdp-fit__item--match')) return;
    item.classList.add('pdp-fit__item--match');
    item.insertBefore(flagNode(), item.firstChild);
    item.parentNode.insertBefore(item, item.parentNode.firstChild);
  }

  function buildItem(v) {
    const li = document.createElement('li');
    li.className = 'pdp-fit__item pdp-fit__item--match';
    if (v.gid) li.setAttribute('data-vehicle-gid', v.gid);
    li.setAttribute('data-fit-injected', '');
    li.appendChild(flagNode());

    const brand = document.createElement('span');
    brand.className = 'pdp-fit__brand';
    brand.textContent = v.brand || '';
    li.appendChild(brand);

    const model = document.createElement('span');
    model.className = 'pdp-fit__model';
    model.textContent = v.model || '';
    li.appendChild(model);

    const years = yearLabel(v);
    if (years) {
      const y = document.createElement('span');
      y.className = 'pdp-fit__years';
      y.textContent = years;
      li.appendChild(y);
    }
    return li;
  }

  /* Bei >50 Fahrzeugen ist data-fits-vehicles gekappt — dann über den
     Frontend-Index prüfen, ob dieses Produkt zum Fahrzeug gehört. */
  async function fitsViaIndex(box, vehicle) {
    const sku = box.dataset.fitsSku;
    const url = box.dataset.fitsIndex;
    if (!sku || !url || !vehicle.handle) return false;
    try {
      const res = await fetch(url);
      if (!res.ok) return false;
      const index = await res.json();
      const skus = index[vehicle.handle];
      return Array.isArray(skus) && skus.indexOf(sku) !== -1;
    } catch (e) {
      return false;
    }
  }

  /* Alte Markierung entfernen — nötig bei Fahrzeugwechsel und wenn das
     Fahrzeug ganz abgewählt wird ("Filter entfernen" in der Leiste). */
  function clearMatch(list) {
    const injected = list.querySelector('[data-fit-injected]');
    if (injected) injected.remove();
    list.querySelectorAll('.pdp-fit__item--match').forEach((el) => {
      el.classList.remove('pdp-fit__item--match');
      const flag = el.querySelector('.pdp-fit__match-flag');
      if (flag) flag.remove();
    });
  }

  async function applyMatch() {
    const box = document.querySelector('.pdp-box--fitment');
    if (!box) return;
    const list = box.querySelector('.pdp-fit');
    if (!list) return;

    clearMatch(list);

    const vehicle = storedVehicle();
    if (!vehicle) return;
    if (!vehicle.gid && !vehicle.model) return;

    /* 1) Steht das Fahrzeug schon in den sichtbaren drei Zeilen? */
    const shown = findMatch(list, '.pdp-fit__item', vehicle);
    if (shown) { markExisting(shown); return; }

    /* 2) Sonst in der vollständigen Liste im Modal suchen … */
    let fits = !!findMatch(box, '.pdp-fitmodal__item', vehicle);
    /* 3) … dann über die GID-Liste der Box … */
    if (!fits) fits = (box.dataset.fitsVehicles || '').split(',').indexOf(vehicle.gid) !== -1;
    /* 4) … und bei über 50 Fahrzeugen zuletzt über den Frontend-Index. */
    if (!fits && box.hasAttribute('data-fits-truncated')) fits = await fitsViaIndex(box, vehicle);
    if (!fits) return;

    list.insertBefore(buildItem(vehicle), list.firstChild);
    while (list.children.length > 3) list.removeChild(list.lastElementChild);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMatch);
  } else {
    applyMatch();
  }
  document.addEventListener('tsstec:vehicle:changed', applyMatch);
  document.addEventListener('tsstec:vehicle:cleared', applyMatch);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-widerrufsformular"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.querySelector('[data-widerruf-form]');
  if (!form) return;
  var errorEl = form.querySelector('[data-widerruf-error]');
  var submitBtn = form.querySelector('[data-widerruf-submit]');
  var successEl = document.querySelector('[data-widerruf-success]');
  var successText = document.querySelector('[data-widerruf-success-text]');

  function showError(msg) {
    if (!errorEl) return;
    errorEl.innerHTML = msg;
    errorEl.hidden = false;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (errorEl) errorEl.hidden = true;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Wird gesendet …';
    }

    fetch(form.dataset.endpoint, {
      method: 'POST',
      body: new FormData(form),
    })
      .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d }; }); })
      .then(function (res) {
        if (!res.data.ok) {
          throw new Error(res.status === 429 ? 'Zu viele Versuche — bitte warte kurz und versuche es erneut.' : '');
        }
        form.hidden = true;
        if (successText && res.data.received_at) {
          successText.textContent =
            'Eingegangen am ' + res.data.received_at + '. ' +
            'Die Eingangsbestätigung wurde an deine E-Mail-Adresse gesendet.';
        }
        if (successEl) successEl.hidden = false;
        successEl && successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      })
      .catch(function (err) {
        showError(
          (err && err.message ? err.message : 'Das Formular konnte gerade nicht übermittelt werden.') +
          ' Alternativ kannst du deinen Widerruf per E-Mail an ' +
          '<a href="mailto:service@tsstec.com?subject=Widerruf">service@tsstec.com</a> senden.'
        );
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Widerruf absenden';
        }
      });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
